import classNames from "classnames";
import React, { useState } from "react";
import { ContactDataResponse } from "../../../integrations/allkort/graphql/interface/Customer";
import { EMAIL_TYPES, filterEmailsByType } from "../../../utils/filterEmailsByType";
import { AtIcon } from "../../svgs/ExpressonSVGs";

/**
 * This component handles the email delivery options for both credit card and smart card sections in profile settings. It receives the card type as a prop to determine which section it belongs to and renders the appropriate options for that card type. The actual functionality for managing email addresses and saving the chosen delivery method is yet to be implemented, so currently it serves as a placeholder for the UI elements related to email delivery settings.
 * This delivery method is used in both the ProfileSmartcard and ProfileCreditCard components to avoid code duplication since the email delivery options are the same for both sections.
 *
 * @param cardType - A string indicating the type of card ("P" for SmartCard or "K" for CreditCard) to determine which section's email delivery options to render.
 * @returns A React component that displays the email delivery options for the specified card type.
 */

type EmailDeliveryCardType = "P" | "K"

type EmailDeliveryProps = {
	cardType: EmailDeliveryCardType
	isActiveMethod: boolean
	customerContactData: ContactDataResponse
	onSelect?: () => void
}

const CardEmailDelivery: React.FC<EmailDeliveryProps> = ({ cardType, isActiveMethod, customerContactData, onSelect }) => {
	const [clicked, setClicked] = useState(false);

	const radiobuttonClickHandler = () => {
		if (!isActiveMethod && onSelect) {
			onSelect();
			return;
		}
		setClicked(true);
		setTimeout(() => {
			setClicked(false);
		}, 3000);
	}

	// Filter emails by type - using Main Email type (ID: 6)
	const { found: hasMainEmail, emails: mainEmails } = filterEmailsByType(
		customerContactData?.currentCustomer?.emails,
		EMAIL_TYPES.INVOICE_STATEMENT
	);

	return (
		<>
			<div
				className={classNames(
					"method",
					'email-delivery-method-component',
					{ "active": isActiveMethod, }
				)}
				tabIndex={0}
				onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); radiobuttonClickHandler(); } }}
				onClick={radiobuttonClickHandler}
			>
				<div
					className="method-header"
				>
					<span
						className={classNames(
							"method-icon",
							{ 'clicked': clicked }
						)}
					>{/* Empty: CSS will fill in the visuals. */}</span>

					<div className="method-content">
						<span className="method-name">Via e-post</span>
						<p>{cardType === "P" ? 'Kontobeskedet' : 'Fakturan'} skickas till valda e-postadresser.</p>
					</div>

					<AtIcon width={45} height={45} />
				</div>

				{/*Show listed emails  */}
				{isActiveMethod && (
					<div className="delivery-emails">
						<div className="divider-horizontal-second"></div>

						<div className="delivery-emails-header">
							<span className="delivery-emails-header-text">Mottagare</span>
						</div>
						<div className="delivery-emails-list">
							{hasMainEmail && mainEmails.map((email, index) => (
								<div key={index} className="delivery-email-item">
									<span className="email">{email}</span>
								</div>
							))}
						</div>

					</div>
				)}



			</div>


		</>
	)
}

export default CardEmailDelivery;